module.exports = function() {
  return new Worker(__webpack_public_path__ + "ad6b30a20743b31edb8d.worker.js");
};